//
//
//
//
//
//
//
//
//
//
//
//
//
//

//右上角三点下拉
export default {
    props: {
        value: {
            type: Boolean,
            default:false
        },
        list: {
            type: Array,
            default: function(){
                return []
            }
        }
    },
    data () {
        return {
            //显示
            visible: false,
            tabIndex: 0
        }
    },
    //计算属性
    computed: {

    },
    watch: {
        value(val) {
            this.visible = val;
        },
        visible(val) {
            this.$emit('input', val);
        }
    },
    beforeDestroy() {
        $('body').off('touchmove');
    },
    mounted() {
        if (this.value) {
            this.visible = true;
        }

        let self = this;
        $('body').on('touchmove', function(e){
            if(self.visible && ($(e.target).parents('.menu').length <= 0 && !$(e.target).hasClass('menu'))){
                self.visible = false;
            }
        });
    },
    methods: {
        onClick(item, index){
            this.tabIndex = index;
            this.$emit('on-click', item);
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/c-menuList/c-menuList.vue